import { __makeTemplateObject } from "tslib";
import { css } from '../../../../../foundation';
export var MoreMenuTabStyle = function (_a) {
    var orientation = _a.orientation;
    var isVertical = orientation === 'vertical';
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n\n    ", "\n  "], ["\n    position: absolute;\n    bottom: 0;\n\n    ",
        "\n  "])), isVertical
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          width: 100%;\n        "], ["\n          width: 100%;\n        "]))) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          top: 0;\n          right: 0;\n        "], ["\n          top: 0;\n          right: 0;\n        "]))));
};
var templateObject_1, templateObject_2, templateObject_3;
